import { Product, ProductSector, TradingEntityClearing } from 'api'
import { OnOffProductsPanelGridRow } from 'view/shared/datagrid/products/OnOffProductsPanelGrid'

export const getProductsRowData = (
  localTradingEntityClearing: TradingEntityClearing,
  productSectors: Record<string, ProductSector>,
  products: Record<string, Product>
): OnOffProductsPanelGridRow[] => {
  const statuses =
    localTradingEntityClearing.productSectorIds &&
    localTradingEntityClearing.productSectorIds.reduce((record, productSectorId) => {
      record[productSectorId] = true
      return record
    }, {} as Record<string, boolean>)

  return Object.keys(productSectors).map(productSectorId => ({
    productSector: productSectors[productSectorId],
    product: products[productSectors[productSectorId].productId],
    status: (statuses && statuses[productSectorId]) || false
  }))
}
